import { render } from "./VacationBenefitsHistory.vue?vue&type=template&id=d7c5a4e6&ts=true"
import script from "./VacationBenefitsHistory.vue?vue&type=script&lang=ts"
export * from "./VacationBenefitsHistory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__